











































import { Component, Vue, PropSync, Prop } from "vue-property-decorator";
import DSelectbox from "@/components/DSelectbox/selectbox.vue";
import { DxButton } from "devextreme-vue/ui/button";
import { DxPopup } from "devextreme-vue";
import { User } from "@/services/data/user_manager";
import UserAccessService from "@/services/user_access_service";

@Component({
    name: "popupCopyAccessRights",
    components: {
    DxButton,
    DxPopup,
    DSelectbox
    }
})
export default class extends Vue {
@Prop() public activeUserId: string | null;
@Prop() public all_users: User[];
@PropSync('popupOptions') public localPopupOptions: any;
public  currentUserId: string | null = null;
public filtered_users: User[] = [];
public active_user_node: number | null = null;



async created() {


}

async mounted() {
}

async onShowing() {
    const active_user = this.all_users.find((u:User) => u.id === this.activeUserId);
    if (active_user?.id_eco_heat_node) this.active_user_node = active_user.id_eco_heat_node;
    if (active_user?.role === "bc91ad0b-75aa-42ec-8f51-116e6e29c8c0") {
        this.filtered_users = this.all_users.filter((u:User) => u.role === "bc91ad0b-75aa-42ec-8f51-116e6e29c8c0" && u.id !== this.activeUserId )
    } else {
        this.filtered_users = this.all_users.filter((u:User) => u.role !== "bc91ad0b-75aa-42ec-8f51-116e6e29c8c0" && u.id !== this.activeUserId )
    }

}


async onCopy() {
    if (this.currentUserId && this.activeUserId) {
        const response = await UserAccessService.copy(this.currentUserId,  this.activeUserId, this.active_user_node);
        if (response) {
            this.$emit('reaload_access');
            this.onClose();
        }        
    }
    
}

onClose() {
    this.localPopupOptions.visible = false;
}


}
